import { PowerSocketChIcon } from './PowerSocketChIcon';

/**
 * author: Stautob
 * id 27B28F1C-C311-49C2-B3EE-6D288A9F1165
 * name power-socket-ch
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket-ch.svg
 * tags
 * - Home Automation 
 */
export const PlugSocketTypeJIcon = PowerSocketChIcon;
export default PlugSocketTypeJIcon